declare global {
    interface Array<T> {
        last(): any;
        objAvg(prop: string): number;
    }
}

export default function generateTracerouteHop(
    hop: string,
    hostname: string,
    ip: string,
    land: string,
    provider: string,
    paketverlust: string,
    countrycode: string 
) {
    return `<tr><td class="text" data-title="${TRACEROUTESTRINGS['HOP']}">${hop}</td>
<td class="text" data-title="${TRACEROUTESTRINGS['Hostname']}">${hostname}</td>
<td class="text" data-title="${TRACEROUTESTRINGS['IP']}">${ip}</td>
<td class="text" data-title="${TRACEROUTESTRINGS['Land']}"><span class="flag-icon flag-icon-${countrycode.toLowerCase()}"></span> ${land}</td>
<td class="text" data-title="${TRACEROUTESTRINGS['Provider']}">${provider}</td>
<td class="text" data-title="${TRACEROUTESTRINGS['Paketlaufzeit']}">${paketverlust} ms</td></tr>`;
}

export function generateEmptyHop() {
    return `<tr><td class="text" data-title="${TRACEROUTESTRINGS['HOP']}">--</td>
<td class="text" data-title="${TRACEROUTESTRINGS['Hostname']}">--</td>
<td class="text" data-title="${TRACEROUTESTRINGS['IP']}">--</td>
<td class="text" data-title="${TRACEROUTESTRINGS['Land']}">--</td>
<td class="text" data-title="${TRACEROUTESTRINGS['Provider']}">--</td>
<td class="text" data-title="${TRACEROUTESTRINGS['Paketlaufzeit']}">--</td></tr>`;
}

interface errorCodeType {
    [key: string]: string | undefined
}

export const errorCode: errorCodeType = {
    '-1' : 'Ping Timeout (-1)',
    '-2' : 'Ping fehlgeschlagen (-2)',
    '-3' : 'Interner Fehler (-3)',
    '-4' : 'Ping oder Traceroute fehlgeschlagen (-4)',
    '-5' : 'Kein Slot auf dem Server frei - bitte wählen Sie ein anderen Server oder probieren Sie es später erneut',
    '-6' : 'Hostname konnte nicht aufgelöst werden'
};

export {};
